<!-- <button *ngIf="fullPath != ''" (click)="onClick()"> -->
<button  (click)="onClick()">
    <mat-icon data-test="btn-ajuda">help_outline</mat-icon>
</button>